import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  InAppBrowser,
  InAppBrowserOptions,
} from '@awesome-cordova-plugins/in-app-browser/ngx';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
} from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.page.html',
  styleUrls: ['./order-details.page.scss'],
})
export class OrderDetailsPage implements OnInit {
  o_id: any;
  tot: any;
  res_name: any;
  orders: any;
  schedule_time: any;
  instructions: any;
  time: any;
  total_price_with_extras: number;
  total_price: number;
  userChoices: any = [];
  categories: any;
  category: any;
  object: any;
  payment_type: any;
  doordash_data: any;
  constructor(
    public globals: GlobalVariable,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public server: ServerService,
    public navCtrl: NavController,
    public router: Router,
    public modalCtrl: ModalController,
    public iab: InAppBrowser
  ) {
    this.orders = this.router.getCurrentNavigation().extras?.state?.data;
    this.time = this.router.getCurrentNavigation().extras?.state?.time;
    this.instructions =
      this.router.getCurrentNavigation().extras?.state?.instructions;
    console.log(this.instructions);
    this.schedule_time =
      this.router.getCurrentNavigation().extras?.state?.schedule_time;
    this.res_name = this.router.getCurrentNavigation().extras?.state?.res;
    this.tot = this.router.getCurrentNavigation().extras?.state?.tot;
    this.o_id = this.router.getCurrentNavigation().extras?.state?.o_id;
    this.payment_type =
      this.router.getCurrentNavigation().extras?.state?.p_type;
    this.doordash_data =
      this.router.getCurrentNavigation().extras?.state?.doordash_data;
    console.log('doordash ', this.doordash_data);
  }
  ionViewWillEnter() {}

  ngOnInit() {}
  close() {
    this.modalCtrl.dismiss();
  }
  trackOrder() {
    const options: InAppBrowserOptions = {};
    //   console.log( doordash_data)
    let url = this.doordash_data.tracking_url;
    const browser = this.iab.create(url, '_system');
  }
  showDetails() {
    if (this.globals.business_type == 'ordering') {
      // const browser = this.iab.create(this.globals.BaseUrl + 'business_controller/order_pdf/' + this.o_id, '_blank');
    } else if (
      this.globals.business_type == 'retail' ||
      this.globals.business_type == 'salon'
    ) {
      // const browser = this.iab.create(this.globals.BaseUrl + 'business_controller/retail_order_pdf/' + this.o_id, '_blank');
    }
  }
  async ReorderVerificationPrompt(orderdata) {
    let prompt = await this.alertCtrl.create({
      header: 'Alert',
      message:
        'Your reorder will be placed in your cart. Click the cart icon to proceed with your order.',
      buttons: [
        {
          text: 'Cancel',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Okay',
          handler: (data) => {
            console.log('OK clicked', orderdata);
            orderdata = orderdata.filter(function (item) {
              return item.reward === false;
            });
            this.globals.Product = orderdata;
            this.navCtrl.navigateRoot('home');

            // this.Categories(orderdata);
          },
        },
      ],
    });
    prompt.present();
  }

  async Categories(orderdata) {
    let loading = await this.loadingCtrl.create({
      message: 'loading...',
    });
    loading.present();
    console.log(orderdata);

    let response = this.server.GetBusinessMenuCategories(orderdata[0].restId);
    response.subscribe(
      (data) => {
        var res = data;
        console.log(res);
        loading.dismiss();
        // console.log(this.data.categories);
        this.category = res.categories;
        console.log('data', this.category);
        //this.userChoices.length = 0;
        orderdata.forEach((userdata) => {
          console.log(userdata);
          this.category.forEach((element) => {
            console.log(userdata.menuItem, element, element.tax);
            this.globals.tax = element.tax;
            element.items.forEach((subelement) => {
              if (userdata.menuItem == subelement.name) {
                if (userdata.menuExtrasSelected.length == 0) {
                  console.log(userdata.quantity, userdata.restId);

                  let total_price =
                    Number(userdata.quantity) * Number(subelement.price);
                  console.log(this.globals.Product);
                  if (userdata.reward == false) {
                    this.globals.Product.push({
                      menuId: '1',
                      restId: userdata.restId,
                      uniqueId: '1',
                      menuItem: subelement.name,
                      image: subelement.image,
                      quantity: userdata.quantity,
                      basePrice: Number(subelement.price),
                      totalPrice: Number(total_price),
                      menuExtrasSelected: [],
                    });
                  }
                  console.log('global product', this.globals.Product);
                  this.navCtrl.navigateRoot('home');
                } else {
                  console.log(userdata.menuExtrasSelected, subelement);
                  console.log('else');

                  this.total_price_with_extras =
                    Number(userdata.quantity) * Number(subelement.price);
                  console.log('global product', this.globals.Product);
                  this.getExtras(subelement.id, userdata.menuExtrasSelected);

                  if (userdata.reward == false) {
                    this.globals.Product.push({
                      menuId: '1',
                      restId: userdata.restId,
                      uniqueId: '1',
                      menuItem: subelement.name,
                      image: subelement.image,
                      quantity: userdata.quantity,
                      basePrice: Number(subelement.price),
                      totalPrice: Number(this.total_price_with_extras),
                      menuExtrasSelected: this.userChoices,
                    });
                  }
                  console.log('global product', this.globals.Product);
                  this.navCtrl.navigateRoot('home');
                }
              }
            });
          });
        });

        //console.log("data1",this.data);

        // console.log(this.data.restaurant.categories);
        // console.log(this.category);
      },
      async (error) => {
        console.log(error);
        loading.dismiss();
        let alert = await this.alertCtrl.create({
          header: 'Error',
          subHeader: 'Server times out, please try again',
          buttons: ['OK'],
        });
        alert.present();
      }
    );
  }

  getExtras(ItemId, userExtras) {
    let response = this.server.ProductItemDetail(ItemId);

    response.subscribe(
      (data) => {
        console.log(data.item.extras);
        console.log(userExtras);

        userExtras.forEach((userextra_element) => {
          console.log(userextra_element);

          data.item.extras.forEach((data_extra_element) => {
            console.log(data.item.extras);
            console.log(userextra_element.optionNameSelected);

            userextra_element.optionNameSelected.forEach(
              (user_option_element) => {
                data_extra_element.options.forEach((data_option_element) => {
                  if (user_option_element.name == data_option_element.name) {
                    this.total_price_with_extras +=
                      user_option_element.quantity *
                      Number(data_option_element.price);
                    var data = {
                      heading: data_extra_element.heading,
                      optionNameSelected: [
                        {
                          name: data_option_element.name,
                          price: Number(data_option_element.price),
                          quantity: user_option_element.quantity,
                          total:
                            Number(data_option_element.price) *
                            user_option_element.quantity,
                          isFree: false,
                        },
                      ],
                    };
                    console.log(data);
                    this.userChoices.push(data);
                    console.log(this.userChoices);
                  }
                });
              }
            );
          });
        });
      },
      async (error) => {
        console.log(error);
        let alert = await this.alertCtrl.create({
          header: 'Error',
          subHeader: 'Server times out, please try again',
          buttons: ['OK'],
        });
        alert.present();
      }
    );
  }
}
